import { Prescription, StandardPrescription } from '../types';

import { isStandardMedicinePrescription } from './isStandardMedicinePrescription';

export const isStandardPrescription = (prescription: Prescription): prescription is StandardPrescription => {
   return isStandardMedicinePrescription(prescription.medicinePrescription);
};
